import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "assets/svgIcons/SearchIcon";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import CloseIcon from "assets/svgIcons/CloseIcon";
import { GLOBAL_SITE_SEARCH } from "globalStore/globalStore";

export const SiteBoxInput = (props) => {
  const {
    getCarsStatus,
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
  } = useSelector((state) => state.commonReducers) || [];
  
  const { siteSearchValue } = useHookstate(GLOBAL_SITE_SEARCH);
  const [searchInput, setSearchInput] = useState(siteSearchValue.get());

  useEffect(() => {
      props.setSearchText(searchInput?.toUpperCase());
  }, [searchInput]);

  const inputRef = useRef();

  useEffect(() => {
    inputRef.current.focus();
  }, [
    getCarsStatus,
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
  ]);

  return (
    <>
      <input
        type="text"
        ref={inputRef}
        value={searchInput}
        onChange={(e) => {
          setSearchInput(e.target.value);
        }}
      />
      <span className="search-icon">
        <SearchIcon color="#000000" />
      </span>
      <span className="close-icon">
        <button
          onClick={() => {
            setSearchInput("");
          }}
        >
          <CloseIcon width={15} height={23}></CloseIcon>
        </button>
      </span>
    </>
  );
};
